import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Config } from 'src/app/_models/config'; // Make sure to import the Config model

@Component({
  selector: 'app-voice-selector',
  templateUrl: './voice-selector.component.html',
  styleUrls: ['./voice-selector.component.scss']
})
export class VoiceSelectorComponent {
  @Input() voices: any[];
  @Input() selectedVoice: any;
  @Input() config: Config; // Add this input
  @Output() selectedVoiceChange = new EventEmitter<any>();

  selectVoice(voice: any) {
    this.selectedVoice = voice;
    this.selectedVoiceChange.emit(this.selectedVoice);
  }

  playAudio() {
    const path = this.selectedVoice.file;
    const audio = new Audio(path);
    audio.play();
  }
}